import { defineComponent } from 'vue';
export default defineComponent({
    name: 'UnlockModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        text: {
            type: String,
            default: ''
        },
        planType: {
            type: String,
            default: "TODAY"
        }
    },
    setup(_, cxt) {
        const stopPopup = event => {
            event.stopPropagation();
            event.preventDefault();
        };
        const toTask = () => {
            cxt.emit('toTask');
        };
        return {
            stopPopup,
            toTask
        };
    }
});
